import React, { Component } from 'react';
import MainDrawer from './InternalNavigation/drawer';
import InternalNavigation from './InternalNavigation';
import AccountSettingsForm from './Settings/form'
import './stylesheets/Settings.sass'


class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawer: false
    };
  }

  toggleDrawer = () => {
    this.setState({drawer: !this.state.drawer})
  }


  render () {
    return (
      <div>
        <MainDrawer
          position={'left'}
          openState={this.state.drawer}
          toggleDrawer={this.toggleDrawer}
          className='drawer'/>
        <InternalNavigation
          toggleDrawer={this.toggleDrawer}/>
        <div className={'settings'}>
          <div className={'settings-title-wrapper'}>
            <div className={'settings-title'}>
              Settings
            </div>
          </div>
          <AccountSettingsForm />
        </div>
      </div>
    );
  }

};

export default Settings;



// WEBPACK FOOTER //
// ./src/Settings.jsx